

/* 原型链继承 */
export function inheritPrototype(subType, superType) {
    let prototype = Object.create(superType.prototype)
    prototype.constructor = subType
    subType.prototype = prototype
}


/* 判空 */
export function isDef(v) {
    return v !== undefined && v !== null && v !== ''
}


export function isEmptyObject(obj) {
    let name;
    for (name in obj) {
        return false
    }
    return true
}

/* 获取数组对象中最大值 */
export function getObjMaxValue(data, attr) {
    let maxValue = 100
    if (data.length <= 0) {
        return maxValue
    } else {
        maxValue=isDef(attr) ? parseFloat(data[0][attr]) :parseFloat(data[0])
        for (let i = 1; i < data.length; i++) {
            try {
                let item = isDef(attr) ? parseFloat(data[i][attr]) : parseFloat(data[i])
                if (maxValue < item) {
                    maxValue = item
                }
            } catch (e) {
                return '';
            }
        }
        return maxValue
    }
}

/* 获取数组对象中最大值 */
export function getObjMinValue(data, attr) {
    let minValue = 0;
    if (data.length <= 0) {
        return minValue
    } else {
        minValue=isDef(attr) ? parseFloat(data[0][attr]) : parseFloat(data[0])
        for (let i = 1; i < data.length; i++) {
            try {
                let item = isDef(attr) ? parseFloat(data[i][attr]) :parseFloat(data[i])
                if (minValue > item) {
                    minValue = item
                }
            } catch (e) {
                return '';
            }
        }
        return minValue
    }
}


/*随机生成颜色*/
export function randomRgbColor() { //随机生成RGB颜色
    var r = Math.floor(Math.random() * 256); //随机生成256以内r值
    var g = Math.floor(Math.random() * 256); //随机生成256以内g值
    var b = Math.floor(Math.random() * 256); //随机生成256以内b值
    return `rgb(${r},${g},${b})`; //返回rgb(r,g,b)格式颜色
}


//val 数据  splitNum：数据分割位数
export function absVal(val, splitNum) {
    try {
        let data = isDef(val) ? Math.abs(val) : '';
        if (isDef(splitNum)) {
            let str = val.toString();
            let reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
            data = str.replace(reg, "$1,");
        }
        return data;
    } catch (e) {
        return '';
    }
}




